const EVENTS_PORTAL = 'events-portal';

export default EVENTS_PORTAL;
